import styled from "styled-components";
import {size} from '../../helpers/breakpoints'

export const Container = styled.div`
  overflow: hidden;
  height: 100vh;
  width: 360px;
  right: 60px;
  position: absolute;
  z-index: 11;
  visibility: hidden;
  
  &.active {
    visibility: visible;
  }

  @media only screen and (max-width: ${size.sm}) {
    width: calc(100vw - 60px);
    padding-bottom: 65px;
  }
  
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: var(--main-color);
  transition: .3s;
  transform: translateX(100%);

  &.active {
    transform: translateX(0);
  }
`;

export const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, .3);
  transition-delay: ${props => props.active ? 0 : '.22s'};
  visibility: ${props => props.active ? 'visible' : 'hidden'};
`;


export const TitleContainer = styled.div`
  width: 100%;
  padding: 1.35rem 1rem;
  border-bottom: 1px solid var(--border-color);
`;

export const Title = styled.p`
  //font-size: .9rem;
  text-align: right;
`;
